import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionTitle from '@/components/feature/SectionTitle';

export default function FeaturedSection() {
  const featured = articles[0];
  const sideArticles = articles.slice(1, 5);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionTitle
          title="精选爆料"
          subtitle="FEATURED"
          action={{ label: '查看更多', href: '/category/dujia-mengliao' }}
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-6">
          <div className="lg:col-span-3">
            <Link
              to={`/article/${featured.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all hover:shadow-md"
            >
              <div className="relative aspect-video lg:aspect-[16/10] overflow-hidden">
                <img
                  src={featured.imageUrl}
                  alt={featured.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex gap-1">
                  {featured.isExclusive && (
                    <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-md backdrop-blur-sm">
                      独家首发
                    </span>
                  )}
                  {featured.isHot && (
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md backdrop-blur-sm">
                      热榜
                    </span>
                  )}
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {featured.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3">
                  {featured.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <div className="flex items-center gap-3">
                    <span className="font-medium text-foreground-600">{featured.author}</span>
                    <span>{featured.publishDate}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {featured.viewCount > 10000 ? `${(featured.viewCount / 10000).toFixed(1)}万` : featured.viewCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-3-line" />
                      {featured.commentCount}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {sideArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}